jQuery(document).ready(function($) {
    const $sliders = $('.u-slider');
    const defaultSettings = {
        keyboard: {
            enabled: true,
        },
        grabCursor: true,
        spaceBetween: 64,
        createElements: true,
        breakpoints: null,
    };
    const swiper = [];

    manageSwiper();

    window.addEventListener('resize', function() {
        manageSwiper();
    });

    function manageSwiper() {
        const windowWidth = $(window).width();

        $sliders.each(function(index, element) {
            const $this = $(this);
            const sliderSettings = $this.data('options');
            const settings = $.extend({}, defaultSettings, sliderSettings);

            swiper[index] = new Swiper($this[0], settings);

            $.each(settings['breakpoints'], function(breakpoint, setting) {
                if (setting['enabled'] == false && (windowWidth >= breakpoint) && $this.hasClass('swiper-initialized')) {
                    swiper[index].destroy();

                    $this.find('.swiper-wrapper').children().unwrap();
                } else if (setting['enabled'] && !$this.hasClass('swiper-initialized') && (typeof breakpoint == 'undefined' || windowWidth >= breakpoint)) {
                    $this.wrapInner('<div class="swiper-wrapper"></div>');

                    if (typeof settings['pagination'] !== 'undefined') {
                        $this.append('<div class="swiper-pagination"></div>');
                    }

                    swiper[index] = new Swiper($this[0], settings);
                }
            });
        });
    }
});
